/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function PrivacyPolicyInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Privacy Protection Policy and Guidelines for Political Entities"
              description={
                <>
                  <h4>Elections Nova Scotia (ENS) respects the privacy of voters and is committed to protecting the integrity of electoral information. ENS has a policy regarding privacy protection and breach reporting to ensure that voter information collected by ENS is protected, used for electoral purposes only, and the privacy and security of the data is maintained. The Privacy Protection Policy is the foundation of ENS’s privacy framework, which also includes Privacy Protection Guidelines for political entities.</h4>
                  <br/>
                  <h3>Elections Nova Scotia Privacy Protection Policy</h3>
                  <br/>
                  <p>Elections Nova Scotia has developed this privacy protection policy to govern how the agency handles the personal information it collects and shares with registered political parties and candidates. The policy outlines how the agency takes reasonable precautions to ensure the privacy and security of personal information. The policy also outlines the processes in place to track the distribution of elector personal information, and the procedures that would be engaged in the case of a privacy breach.</p>
                  <br/>
                  <p><ul style={{ paddingLeft: "40px" }}>
                    <li><a href="/files/PrivacyPolicy/PrivacyProtectionPolicy_2022_PostedJan2024.pdf">Privacy Protection Policy</a></li>
                  </ul></p>

                  <br/>
                  <h3>Privacy Protection Guidelines for Political Entities</h3>
                  <br/>
                  <p>To assist registered political parties and candidates (political entities), Elections Nova Scotia has developed privacy protection guidelines to encourage political entities to develop privacy protection practices and breach reporting protocols.</p>
                  <br/>
                  <p><ul style={{ paddingLeft: "40px" }}>
                    <li><a href="/files/PrivacyPolicy/PrivacyGuidelines_2024.pdf">Privacy Protection Guidelines for Political Entities</a></li>
                  </ul></p>
                  <br/>
                  <h3><em>Freedom of Information and Protection of Privacy Act</em></h3>
                  <br/>
                  <p>As a public sector agency, Elections Nova Scotia is accountable under the provincial <em><a href="http://nslegislature.ca/legc/statutes/freedom.htm">Freedom of Information and Protection of Privacy Act</a></em>. Our Privacy Protection framework is rooted in that <em>Act</em>, other legislation, and fair information practices.</p>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default PrivacyPolicyInformation;
